const Divider = () => {
  return <div className="h-[1px] w-full bg-gray-200 my-3" />;
};

export default Divider;
